module.exports = __webpack_public_path__ + "static/media/logo.70286263.png";